import { authErrorAction } from '../auth'
import { clearProjectAction } from '../project'
import { Config } from '../utils/config'

const logoutRequest = async (dispatch) => {
  try {
    const response = await fetch(`${Config.BASE_URL}/logout`, {
      method: 'GET',
      credentials: 'include'
    })
    if (response.ok) {
      await response.json()
      dispatch(authErrorAction())
      dispatch(clearProjectAction())
    } else {
      const errorData = await response.json()
      throw new Error(errorData.error)
    }
  } catch (error) {
    console.error(error)
  }
}

export { logoutRequest }
